import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-income-icon',
  templateUrl: './lib-income-icon.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LibIncomeIconComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
